<div class="container-base">
  <mat-card>
    <mat-card-title>
      <img src="{{logoSrc}}" alt="logo" class="logo" />
    </mat-card-title>
    <mat-card-subtitle>{{title}}</mat-card-subtitle>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field class="full-width-input">
          <input matInput class="lowercase" placeholder="{{ 'labels.email' | translate }}" formControlName="username" required autofocus />
          <mat-error>{{ 'errors.required.email' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field class="full-width-input">
          <input matInput type="password" placeholder="{{ 'labels.password' | translate }}" formControlName="password" required />
          <mat-error>{{ 'errors.required.password' | translate }}</mat-error>
        </mat-form-field>
        <mat-error class="invalid-password" *ngIf="invalid">{{ 'errors.invalid.emailAndOrPassword' | translate }}</mat-error>
        <button mat-raised-button [disabled]="!form.valid" color="primary">{{ 'buttons.login' | translate }}</button>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <a class="reset-password" href="resetpassword">{{ 'labels.resetPassword' | translate }}</a>
    </mat-card-footer>
  </mat-card>
</div>